/**
 * 장면 캔버스와 대체 그림(첫 그림 전·WebGL 없음일 때 보이는 정지 사진)의 인계 — 지형·다리 장면이 같이 쓰고, 장면 칸
 * 스타일(`sceneStyles`)도 같은 값을 읽는다. three.js 를 부르지 않는 모듈이라 스타일이 가져다 써도 첫 화면 묶음이 무거워지지 않는다.
 */

/** 장면 칸 바탕색 — 캔버스 지우기 색·안개 색과 칸 CSS 바탕이 같아야, 캔버스가 나타나는 동안 칸 안에 다른 색 사각형이 보이지 않는다 */
export const SCENE_BACKGROUND = "#E3E8ED";
/** 같은 바탕색의 숫자 표현 — 엔진이 프레임마다 지우기 색으로 넘긴다(색 문자열을 매번 해석하지 않게) */
export const SCENE_BACKGROUND_HEX = Number.parseInt(
  SCENE_BACKGROUND.slice(1),
  16
);
/** 캔버스가 나타나는 시간이자 대체 그림이 사라지는 시간(ms) — 대체 그림은 캔버스가 다 나타난 뒤에 걷는다 */
export const SCENE_CANVAS_FADE_MS = 600;
/** 캔버스·대체 그림이 나타나고 사라지는 전환 */
export const SCENE_CANVAS_FADE = `opacity ${SCENE_CANVAS_FADE_MS}ms ease`;

/** 장면 캔버스를 대체 그림 바로 뒤에 투명하게 붙인다 — 첫 그림을 그린 뒤 `revealSceneCanvas` 로 드러낸다 */
export function mountSceneCanvas(
  root: HTMLElement,
  fallback: HTMLElement,
  canvas: HTMLCanvasElement
) {
  canvas.style.opacity = "0";
  canvas.style.transition = SCENE_CANVAS_FADE;
  root.insertBefore(canvas, fallback.nextSibling);
}

/**
 * 다음 프레임에 캔버스를 드러내고, 다 드러난 뒤 대체 그림을 걷는다 — 덜 나타난 캔버스 아래로 대체 그림이 먼저 빠지면 칸 바탕이 비친다.
 * 돌려준 함수는 아직 걷지 않은 대체 그림 걷기를 취소한다(장면을 치울 때).
 */
export function revealSceneCanvas(
  canvas: HTMLCanvasElement,
  fallback: HTMLElement
): () => void {
  let fallbackTimer = 0;
  requestAnimationFrame(() => {
    canvas.style.opacity = "1";
    fallbackTimer = window.setTimeout(() => {
      fallback.style.opacity = "0";
    }, SCENE_CANVAS_FADE_MS);
  });
  return () => window.clearTimeout(fallbackTimer);
}
